import * as React from 'react'

import { Box, Colors, Icon, MediumIcon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  onClick?: () => void
  icon?: MediumIcon | false
  iconColor?: Colors
}

const AddPeopleCollapsableCardTrigger = ({
  onClick,
  icon,
  iconColor = 'grey700',
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <Box
      onClick={onClick}
      paddingX="s8"
      cursor="pointer"
      background="grey000White"
      alignItems="center"
    >
      <Box
        flexDirection="row"
        alignItems="stretch"
        justifyContent="spaceBetween"
        height="full"
        width="full"
      >
        <Box flexDirection="row" alignItems="center" gap="s6" paddingX="s0">
          {icon && <Icon.Medium icon={icon} color={iconColor} />}
          <Text.Normal size="200" weight="medium" color="grey800">
            {children}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

export default AddPeopleCollapsableCardTrigger
